"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppOnlyAccess = exports.COLLABORATOR_APP_INVITE_FORM_PERMISSIONS = exports.getAllFormPermissions = exports.getOrderedPermissions = exports.getOrderedProductPermissions = exports.orderedActionsPermissions = void 0;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
exports.orderedActionsPermissions = [enums_1.UserPermissions.UserManagement];
const isReceiptPermissionHidden = (organizationCountry) => organizationCountry === country_1.OrganizationCountry.GreatBritain || organizationCountry === country_1.OrganizationCountry.Ireland;
const getOrderedProductPermissions = (organizationCountry) => isReceiptPermissionHidden(organizationCountry)
    ? [
        enums_1.UserPermissions.Donation,
        enums_1.UserPermissions.Ticketing,
        enums_1.UserPermissions.Contacts,
        enums_1.UserPermissions.Bank,
        enums_1.UserPermissions.TapToPay,
    ]
    : [
        enums_1.UserPermissions.Donation,
        enums_1.UserPermissions.Ticketing,
        enums_1.UserPermissions.Contacts,
        enums_1.UserPermissions.Receipt,
        enums_1.UserPermissions.Bank,
        enums_1.UserPermissions.TapToPay,
    ];
exports.getOrderedProductPermissions = getOrderedProductPermissions;
const getOrderedPermissions = (organizationCountry) => [
    ...(0, exports.getOrderedProductPermissions)(organizationCountry),
    ...exports.orderedActionsPermissions,
];
exports.getOrderedPermissions = getOrderedPermissions;
const getAllFormPermissions = (organizationCountry) => Object.values(enums_1.UserFormPermissions).filter((permission) => isReceiptPermissionHidden(organizationCountry) ? permission !== enums_1.UserFormPermissions.Receipt : true);
exports.getAllFormPermissions = getAllFormPermissions;
exports.COLLABORATOR_APP_INVITE_FORM_PERMISSIONS = [
    enums_1.UserFormPermissions.TapToPayGuestList,
    enums_1.UserFormPermissions.TapToPayPayments,
];
const APP_ONLY_FORM_PERMISSIONS = exports.COLLABORATOR_APP_INVITE_FORM_PERMISSIONS;
const isAppOnlyAccess = ({ generalPermissions, formPermissions, }) => generalPermissions.every((permission) => permission === enums_1.UserGeneralPermissions.TapToPay) &&
    formPermissions.length > 0 &&
    formPermissions.every((permission) => APP_ONLY_FORM_PERMISSIONS.includes(permission));
exports.isAppOnlyAccess = isAppOnlyAccess;
